<template>
  <div id="app">
    <b-container fluid class="p-0">
      <!-- shared header -->
      <Header />
      <!-- main content -->
      <b-container fluid class="main-container pl-5 pr-5 flex-grow-1">
        <router-view />
      </b-container>
      <b-container fluid class="pl-5 pr-5">
        <!-- shared footer -->
        <Footer />
      </b-container>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  components: { Header, Footer }
};
</script>
<style>
@import url("https://ux.bluetooth.com/css/bluetooth.min.css?v=1");
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,500,700&display=swap");
</style>
